<template>
  <div class="loader-window-wrapper">
    <div
      class="loader-spinner"
      :class="{
        'xazna-loader': useragent === 'xazna'
      }"
    >
      <i></i>
      <i></i>
      <i></i>
      <i></i>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useUseragent } from '@/helpers/useragent.js'

const useragent = computed(() => useUseragent().getUserAgent())
</script>

<style scoped lang="scss">
.loader-window-wrapper .loader-spinner.xazna-loader i:nth-child(2),
.loader-window-wrapper .loader-spinner.xazna-loader i:last-child {
  background-color: #62c069;
}
.loader-window-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #01010133;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  z-index: 10000;
  .loader-spinner {
    top: 50%;
    left: 50%;
    width: 144px;
    height: 144px;
    margin-top: -72px;
    margin-left: -72px;
    position: absolute;

    i {
      top: 50%;
      left: 50%;
      width: 32px;
      height: 32px;
      display: block;
      margin-top: -16px;
      margin-left: -16px;
      position: absolute;
      background: #FFFFFF;
      border-radius: 32px;

      &:first-child {
        margin-top: -64px;
        margin-left: -16px;
        transform: scale(1);
        animation: spinner 1s ease-in-out infinite alternate;
        animation-delay: 0s;
      }
      &:nth-child(2) {
        margin-top: -16px;
        margin-left: 32px;
        transform: scale(1);
        background-color: #F05039;
        animation: spinner 1s ease-in-out infinite alternate;
        animation-delay: 0.25s;
      }
      &:nth-child(3) {
        margin-top: 32px;
        margin-left: -16px;
        transform: scale(1);
        animation: spinner 1s ease-in-out infinite alternate;
        animation-delay: 0.5s;
      }
      &:last-child {
        margin-top: -16px;
        margin-left: -64px;
        transform: scale(1);
        background-color: #F05039;
        animation: spinner 1s ease-in-out infinite alternate;
        animation-delay: 0.75s;
      }
    }
  }
}
@keyframes spinner {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.6);
  }
  100% {
    transform: scale(1);
  }
}
</style>